module.exports = __webpack_public_path__ + "img/upload-home-icon.9a1fe742.svg";